import styled from 'styled-components';
import { Typography } from '@mui/material';

import colors from '../../../styles/colors';

const PageContainer = styled.div`
  padding: 30px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const PageHeader = styled.div`
  margin-bottom: 24px;
`;

const VersionText = styled(Typography)`
  font-size: 15px;
  font-weight: 600;
  color: ${colors.base.secondary2};
  margin-left: 3px;
`;

const VersionDate = styled(Typography)`
  font-size: 12px;
  color: ${colors.shades.gamma10};
  margin-top: 2px;
  margin-left: 3px;
`;

const FeaturesText = styled(Typography)`
  font-size: 14px;
  color: ${colors.shades.gamma10};
  line-height: 1.5;
  padding-right: 16px;
`;

export {
  PageContainer,
  PageHeader,
  VersionText,
  VersionDate,
  FeaturesText,
};
